export default __webpack_public_path__ + "static/yangol6666-9f87d257322540385fc97ce3f5c180fd.png";